import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationError } from '../../../model/error';
import { ApplicationErrorHandler } from '../../../service/error/application-error-handler';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIcon, MatTooltip]
})
export class ErrorPageComponent {
	private readonly applicationErrorHandler = inject(ApplicationErrorHandler);
	private readonly route = inject(ActivatedRoute);

	private readonly defaultError: ApplicationError = {
		technicalName: 'The error code is either invalid or nonexistant, which I guess is the same thing here',
		friendlyName: 'Unknown Error',
		errorCode: 0,
		actionText: "",
		action: () => {},
		triggerActionImmediately: false
	};

	public readonly id: string | null = this.route.snapshot.queryParamMap.get('id');
	public readonly error: ApplicationError =
		this.applicationErrorHandler.getErrorByErrorIdentifier(this.parseErrorCode()) || this.defaultError;

	public readonly tooltipText = signal('Copy to clipboard');

	public triggerErrorAction(): void {
		if (this.error.action) {
			this.error.action();
		}
	}

	public copy(e: Event): void {
		e.stopPropagation();
		e.preventDefault();
		navigator.clipboard.writeText(this.id as string).then(() => {
			this.tooltipText.set('Copied');
		}).catch(() => {
			this.tooltipText.set('Copy failed. Please select the code and copy it manually.');
		});
	}

	public setTooltipTextDefault(): void {
		setTimeout(() => this.tooltipText.set('Copy to clipboard'), 50);
	}

	private parseErrorCode(): number {
		const parsed = Number(this.route.snapshot.paramMap.get('errorCode'));
		return Number.isNaN(parsed) ? 0 : parsed;
	}
}
